import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetSimilarArticlesReset, EGetSimilarArticlesActionType } from './types';

export const getSimilarArticlesReset: () => TGetSimilarArticlesReset =
  actionGenerator<EGetSimilarArticlesActionType.Reset>(EGetSimilarArticlesActionType.Reset);
